import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { submitBtnValidate } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
let submitBtnSetting = class submitBtnSetting extends Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      submitTitle: "提交",
      submitText: "本活动最终解释权归爱问所有"
    };
    this.rules = {
      submitTitle: [{
        required: true,
        type: "string",
        validator: submitBtnValidate.submitTitle,
        trigger: "blur"
      }],
      submitText: [{
        required: false,
        type: "string",
        validator: submitBtnValidate.submitText,
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], submitBtnSetting.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], submitBtnSetting.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], submitBtnSetting.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], submitBtnSetting.prototype, "watchPostForm", null);
submitBtnSetting = __decorate([Component({
  name: "submitBtnSetting",
  components: {
    questionSettingTemplate
  }
})], submitBtnSetting);
export default submitBtnSetting;